// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'E:/K8s/service-frontend/node_modules/.pnpm/@umijs+renderer-react@4.7.1_67230cc223e6b2a5f27c63803e8c96ee/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
